import { PaginationParams } from '../elearning';

export enum TemplateSort {
  NAME = 'name',
  CREATED_AT = 'created_at',
  MODIFIED_AT = 'modified_at',
}

interface LcmsReferenceIds {
  id: number;
}
interface TemplateMetadata {
  description: string;
  img: string;
  playerType: number;
}
export interface TemplateDataType {
  id: string;
  name: string;
  content: string;
  isFavourite: boolean;
  lcmsReferenceIds: LcmsReferenceIds;
  templateMetadata: TemplateMetadata;
  createdAt?: string;
  modifiedAt?: string;
}

export interface TemplateFormDataType {
  name: string;
  content: string;
  isFavourite: boolean;
  templateMetadata: TemplateMetadata;
}

export interface TemplateType {
  isLoading: boolean;
  isLoaded: boolean;
  error?: Error;
  data: null | [TemplateDataType];
}

export interface GetTemplatesParams extends PaginationParams {
  isFavourite?: boolean;
}
